import React from 'react';

const LocationIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.97679 2.21344C6.25129 1.4729 7.81786 1.48585 9.0804 2.24735C10.3305 3.02436 11.0903 4.41109 11.0832 5.90283C11.0541 7.38479 10.2394 8.77783 9.22103 9.85471C8.63324 10.4791 7.9757 11.0311 7.26183 11.4997C7.18831 11.5422 7.10778 11.5707 7.0242 11.5837C6.94377 11.5802 6.86544 11.5565 6.79628 11.5145C5.70642 10.8105 4.75028 9.91185 3.97387 8.8618C3.32418 7.98529 2.95508 6.92633 2.91667 5.82874C2.91583 4.33414 3.70229 2.95398 4.97679 2.21344ZM5.71327 6.44728C5.92765 6.97581 6.43369 7.32057 6.99511 7.32057C7.3629 7.32321 7.71645 7.17589 7.97698 6.91144C8.23751 6.64698 8.38337 6.28736 8.38207 5.91271C8.38403 5.34085 8.04735 4.82418 7.52924 4.60394C7.01113 4.38371 6.41378 4.50336 6.01611 4.90703C5.61843 5.31069 5.49888 5.91875 5.71327 6.44728Z'
        fill='currentColor'
      />
      <ellipse
        opacity='0.4'
        cx='7.00001'
        cy='12.7503'
        rx='2.91667'
        ry='0.583333'
        fill='currentColor'
      />
    </svg>
  );
};

export default LocationIcon;
